"use client";

import { useMemo } from "react";
import { useTranslations } from "next-intl";

export function useNavigationMessages() {
  const t = useTranslations("Navigation");

  return useMemo(
    () => ({
      logoAlt: t("logoAlt"),
      logoTitle: t("logoTitle"),
      searchPlaceholder: t("searchPlaceholder"),
      searchDefaultPlaceholder: t("searchDefaultPlaceholder"),
      searchMobilePlaceholder: t("searchMobilePlaceholder"),
      searchAriaLabel: t("searchAriaLabel"),
      navButtonLabel: t("navButtonLabel"),
      navMenuOpen: t("navMenuOpen"),
      navMenuClose: t("navMenuClose"),
      getNavMenuAriaLabel: (label: string, isOpen: boolean) =>
        t("navMenuAriaLabel", {
          label,
          state: isOpen ? t("navMenuClose") : t("navMenuOpen"),
        }),
      mobileNavMenuOpen: t("mobileNavMenuOpen"),
      mobileNavMenuClosed: t("mobileNavMenuClosed"),
      signIn: t("signIn"),
      register: t("register"),
      business: t("business"),
      dashboard: t("dashboard"),
      cart: t("cart"),
      accountMenuAlt: t("accountMenuAlt"),
      resumeLastCourse: t("resumeLastCourse"),
      userDashboard: t("userDashboard"),
      career: t("career"),
      profile: t("profile"),
      account: t("account"),
      signOut: t("signOut"),
      mobileLanguageLabel: t("mobileLanguageLabel"),
      closeMenu: t("closeMenu"),
    }),
    [t],
  );
}
